export default __webpack_public_path__ + "static/media/icon_topic_line_chart.4ef7c0c9.svg";